import { render, staticRenderFns } from "./OnlineProfileMetric.vue?vue&type=template&id=825edeb6&scoped=true"
import script from "./OnlineProfileMetric.vue?vue&type=script&lang=js"
export * from "./OnlineProfileMetric.vue?vue&type=script&lang=js"
import style0 from "./OnlineProfileMetric.vue?vue&type=style&index=0&id=825edeb6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825edeb6",
  null
  
)

export default component.exports